import { React, Component } from 'react';
import NewsBOXStyling from '../../components/homeBlock/style.scss';
import Blocks from '../../components/homeBlock/Blocks';
import BlockStyling from '../../components/homeBlock/style.scss';
import style from './style.scss';
import HeaderStyling from '../../components/header/style.scss';
import { API } from '../../components/API/index';
import { Event } from '../../utils/events';
import { changeHeaderTheme } from '../../utils/changeHeaderTheme';
import LetsTalk from '../../components/LetsTalk/index';
import NewsLetterFooter from '../../components/NewsLetterFooter/index';
import Footer from '../../components/footer/index';
import Header from '../../components/header/index';

class CollabsHeader extends Component {
	constructor(props) {
		super(props);

		this.state = {
			basePath       : 'https://dev365.gdpventure.com',
			blockDataLarge : [],
			blockDataSmall : [],
			collabTop      : [],
			blockData      : []
		};
	}

	componentDidMount() {
		fetch('https://dev365.gdpventure.com/drupal-backend/api/connect/collabTop')
			.then((results) => {
				return results.json();
			})
			.then((data) => {
				let collabtop = data.map((logo) => {
					return (
						<div class={style.collabsHeaderContainer}>
							<Header />
							<div class={style.storyDiv}>
								<p class={style.storyTitle}>{logo.title}</p>
								<p class={style.storyDesc}>{logo.field_story_description}</p>
							</div>
							<div class={style.imageDiv}>
								<img src={'https://dev365.gdpventure.com/' + logo.field_collab_top_tmage} />
							</div>
						</div>
					);
				});
				this.setState({ collabtop: collabtop }, () => {
					changeHeaderTheme('transparent-blue');
				});
			});

		/*
      collabs api
      */
		var self = this;
		API.getData('/fetch/collabs')
			.then((res) => {
				if (res && res.length > 0) {
					this.setState({
						blockData   : res,
						apisWorking : true,
						basePath    : 'https://dev365.gdpventure.com'
					});
					// var blockDataLargeCount = 2;
					// var blockDataSmallCount = 6;
					// if (res.length <= 2) {
					//   blockDataLargeCount = res.length;
					//   this.setState({
					//     blockDataLarge: [...res],
					//     blockDataSmall: []
					//   });
					// } else {
					//   if (res.length < 8) {
					//     blockDataSmallCount = res.length - 2;
					//   }
					//   this.setState({
					//     blockDataLarge: res.slice(0, 2),
					//     blockDataSmall: res.slice(2, 2 + blockDataSmallCount)
					//   });
					// }

					var blockDataSmallCount = 6;
					if (res.length <= 6) {
						blockDataSmallCount = res.length;
						this.setState({
							blockDataSmall : [
								...res
							]
						});
					}
					else {
						this.setState({
							blockDataSmall : res.slice(0, 6)
						});
					}
				}
			})
			.catch((error) => console.error(error));
	}

	render() {
		return (
			<div class={style.headerClass} id="globalDiv">
				<div class={style.collabsHeaderContainer}>{this.state.collabtop}</div>
				<div>
					<div class={NewsBOXStyling.newsBoxes} id="news-boxes">
						<div class={NewsBOXStyling.largeBoxContainer}>
							{this.state.blockDataLarge.map((data, index) => {
								return (
									<Blocks
										data={data}
										index={index}
										type="large"
										basePath={this.state.basePath}
										apisWorking={this.state.apisWorking}
									/>
								);
							})}
						</div>
						<div class={NewsBOXStyling.smallBoxContainer}>
							{this.state.blockDataSmall.map((data, index) => {
								return (
									<Blocks
										data={data}
										index={index}
										type="small"
										basePath={this.state.basePath}
										apisWorking={this.state.apisWorking}
									/>
								);
							})}
						</div>
					</div>
				</div>
				<LetsTalk />
				<NewsLetterFooter />
				<Footer />
			</div>
		);
	}
}

export default CollabsHeader;



// WEBPACK FOOTER //
// ./routes/collabs/collabsheader.js